import { render, staticRenderFns } from "./Notificaciones.vue?vue&type=template&id=cdb0a12e"
import script from "./Notificaciones.vue?vue&type=script&lang=js"
export * from "./Notificaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdb0a12e')) {
      api.createRecord('cdb0a12e', component.options)
    } else {
      api.reload('cdb0a12e', component.options)
    }
    module.hot.accept("./Notificaciones.vue?vue&type=template&id=cdb0a12e", function () {
      api.rerender('cdb0a12e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/notificaciones/Notificaciones.vue"
export default component.exports